/**
 * 2019-04-12
 * handan
 * 背调记录页
 */

import React, { Component, Fragment } from 'react'
import "./style.scss";
import {
  Link
} from "react-router-dom";

import { Modal, Tabs, Pagination, message } from "antd";

import { getRecordData, removeRecord, repeat,update } from "../../models";
const { TabPane } = Tabs;
class ResultHistory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataList: {},
      isShowModal: false,
      key: 1,
      index: 1,
      agenModal: false,
      phone: '',
      item: {},
    }
    this.pageSize = 10;
    this.page = 1;
  }

  onChangeInput = (e) => {

    this.setState({
      phone: e.target.value,
    });

  }

  getYMDHMS(timestamp) {
    if (!timestamp) {
      return false;
    }
    let time = new Date(timestamp)
    let year = time.getFullYear()
    let month = time.getMonth() + 1
    let date = time.getDate()
    let hours = time.getHours()
    let minute = time.getMinutes()
    let second = time.getSeconds()

    if (month < 10) { month = '0' + month }
    if (date < 10) { date = '0' + date }
    if (hours < 10) { hours = '0' + hours }
    if (minute < 10) { minute = '0' + minute }
    if (second < 10) { second = '0' + second }
    return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
  }

  void() {
    return (
      <div className="void">
        <img src="//pic1.58cdn.com.cn/nowater/cxnomark/n_v29d5a18e297c04cf79660ad4437e009bd.png" alt="" />
        <p>您还没有历史记录，快去查询吧～</p>
      </div>
    )
  }
  notVoid() {
    const { dataList = {}, index } = this.state;
    return (
      <Fragment>
        {
          dataList.list.map((item, index) => {
            return (
              <div className="content" key={item.batchId}>
                <p style={{ fontSize: '16px', color: '#111111' }}>{item.realName}</p>
                <div className="content-top">
                  {/* <span>姓名：{item.realName}</span> */}
                  {item.idNo && <span>身份证号：{item.idNo}</span>}
                  {item.phoneNo && <span>手机号：{item.phoneNo}</span>}
                </div>
                <p className="content-kind">背调类别：{item.itemName && item.itemName.join(',')}</p>
                <div className="content-center">
                  {item.batchNo && <span>批次编号：{item.batchNo}</span>}
                  <span>订单编号：{item.authNo}</span>
                </div>
                <div className="content-center">
                  <span>授权截至有效期：{this.getYMDHMS(item.expiredTime)}</span>
                </div>
                <p className="content-bottom">候选人授权网址（对方收不到短信时可复制发送给候选人）：{item.authUrl}</p>
                <div>
                  <Link to={`/verifyResult/${item.batchId}`}><button className="btn">查看详情</button></Link>
                </div>
              </div>
            )
          })
        }
        <Pagination
          total={dataList.total}
          onChange={this.onChange}
          current={index}
          pageSize={10}
        >
        </Pagination>
        {/* <div className="pagination">
          <span className={dataList.first && "gray"} onClick={!dataList.first && this.prevClick}>上一页</span>
          <span className={dataList.last && "gray"} onClick={!dataList.last && this.nextClick}>下一页</span>
        </div> */}
      </Fragment>
    )
  }
  notVoid1() {
    const { dataList = {}, index } = this.state;
    return (
      <Fragment>
        {
          dataList.list.map((item, index) => {
            return (
              <div className="content" key={item.batchId}>
                <p style={{ fontSize: '16px', color: '#111111' }}>{item.realName}</p>
                <div className="content-top">
                  {/* <span>姓名：{item.realName}</span> */}
                  {item.idNo && <span>身份证号：{item.idNo}</span>}
                  {item.phoneNo && <span>手机号：{item.phoneNo}</span>}
                </div>
                <p className="content-kind">背调类别：{item.itemName && item.itemName.join(',')}</p>
                <div className="content-center">
                  {item.batchNo && <span>批次编号：{item.batchNo}</span>}
                  <span>订单编号：{item.authNo}</span>
                </div>
                <div className="content-center">
                  {item.authTime && <span>候选人授权时间： {this.getYMDHMS(item.authTime)}</span>}

                </div>
                <div>
                  <button className="close" onClick={() => { this.handleCloseClick(item.authId, 2) }}>删除</button>
                  <Link to={`/verifyResult/${item.batchId}`}><button className="btn">查看详情</button></Link>
                </div>

              </div>
            )
          })
        }
        {/* <Pagination defaultCurrent={1} defaultPageSize={1} total={50}></Pagination> */}
        <Pagination
          total={dataList.total}
          onChange={this.onChange}
          current={index}
          pageSize={10}
        ></Pagination>
        {/* <div className="pagination">
          <span className={dataList.first && "gray"} onClick={!dataList.first && this.prevClick}>上一页</span>
          <span className={dataList.last && "gray"} onClick={!dataList.last && this.nextClick}>下一页</span>
        </div> */}
      </Fragment>
    )
  }
  notVoid2() {
    const { dataList = {}, index } = this.state;
    return (
      <Fragment>
        {/* <p className="content-tip">已支付费用（现金/点数/会员权益），以等额背调点数形式退还到您的背调余额，首页即可查看背调点数。</p> */}
        {
          dataList.list.map((item, index) => {
            return (
              <div className="content" key={item.batchId}>
                {/* {item.tcState == 1 && <span className="yituidian" >已退点</span>}
                {item.tcState == 0 && <span className="tuidianzhong" >退点中</span>} */}
                <p style={{ fontSize: '16px', color: '#111111' }}>{item.realName}</p>
                <div className="content-top">
                  {item.idNo && <span>身份证号：{item.idNo}</span>}
                  {item.phoneNo && <span>手机号：{item.phoneNo}</span>}
                </div>
                <p className="content-kind">背调类别：{item.itemName && item.itemName.join(',')}</p>
                <div className="content-center">
                  {item.batchNo && <span>批次编号：{item.batchNo}</span>}
                  <span>订单编号：{item.authNo}</span>
                </div>
                <div className="content-center">
                  <span>授权失败原因：{item.failReason}</span>
                </div>
                <div>
                  <button className="close" onClick={() => { this.handleCloseClick(item.authId, 3) }}>删除</button>
                  <Link to={`/verifyResult/${item.batchId}`}><button className="btn">查看详情</button></Link>
                  {item.repeatCount != 0 && <button className="close" onClick={this.agen.bind(this, item)}>重试</button>}
                  <span style={{ float: 'right', margin: '10px' }}>余{item.repeatCount}次重试机会</span>
                </div>

              </div>
            )
          })
        }
        {/* <Pagination defaultCurrent={1} defaultPageSize={1} total={50}></Pagination> */}
        <Pagination
          total={dataList.total}
          onChange={this.onChange}
          pageSize={10}
          current={index}
        ></Pagination>
        {/* <div className="pagination">
          <span className={dataList.first && "gray"} onClick={!dataList.first && this.prevClick}>上一页</span>
          <span className={dataList.last && "gray"} onClick={!dataList.last && this.nextClick}>下一页</span>
        </div> */}
      </Fragment>
    )
  }

  agen = (item) => {
    const me = this;
    // const confim = Modal.confirm({
    //   content: '系统将重发授权短信给被核实人好好说话哈哈哈哈，请及时与对方联系，查收【58同城】发的短信登录授权',
    //   okText: '确定',
    //   cancelText: '取消',
    //   onOk: async () => {
    //     // categoryDelete(id);

    //     await repeat(id);

    //     const { key, index } = me.state;
    //     me.getData(key, index);

    //     confim.destroy();

    //   },
    // });
    me.setState({
      agenModal: true,
      item,
    });
  }

  agenOk = async () => {
    const me = this;
    const { phone, item } = me.state;
    const reg = /^1\d{10}$/;
    if (!reg.test(phone)) {
      message.info('请输入正确的手机号！');
      return false;
    }
    await update( item.authId, phone );
    await repeat(item.authId);
    const { key, index } = me.state;
    me.getData(key, index);
    me.onCloseAgenModel();
  }

  render() {
    const { dataList = {}, isShowModal = false, agenModal = false, item } = this.state;
    let isVoid = !dataList.list || dataList.list.length === 0;
    return (
      <div className="ResultHistory-wrap">
        <div className="ResultHistory-wrap_content">
          <Tabs defaultActiveKey="1" onChange={this.callback}>
            <TabPane tab="待授权" key="1">
              <div className="container">
                {
                  isVoid ? this.void() : this.notVoid()
                }
              </div>
            </TabPane>
            <TabPane tab="已完成" key="2">
              <div className="container">
                {
                  isVoid ? this.void() : this.notVoid1()
                }
              </div>
            </TabPane>

            <TabPane tab="授权失败" key="3">
              <div className="container">
                {
                  isVoid ? this.void() : this.notVoid2()
                }
              </div>
            </TabPane>

          </Tabs>
        </div>
        <Modal
          visible={isShowModal}
          wrapClassName="myModal myModal-close"
          footer={null}
          centered={true}
          width={480}
        >
          <div className="statePop bad">
            <p className="bgIcon"></p>
            <p className="name">删除记录</p>
            <span>删除后无法恢复，确定要删除吗？</span>
            <div className="modal-btn">
              <button className="confirm" onClick={this.handleDeleteClick}>确定</button>
              <button className="cancel" onClick={this.onCloseModel}>取消</button>
            </div>
          </div>
        </Modal>
        <Modal
          visible={agenModal}
          wrapClassName="agenModal"
          footer={null}
          // centered={true}
          width={400}
        >
          <div className="agenPop">
            <p className="name">请认真核对求职者（即被核实人）信息</p>
            <div className="item">
              <div className="item_left">
                姓名：
              </div>
              <div className="item_right">
                {item.realName}
              </div>
            </div>
            <div className="item">
              <div className="item_left">
                身份证号：
              </div>
              <div className="item_right">
                {item.idNo}
              </div>
            </div>
            <div className="item">
              <div className="item_left">
                手机号：
              </div>
              <div className="item_right">
                <input
                  type="text"
                  placeholder=""
                  onChange={this.onChangeInput} />
                <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
              </div>
            </div>
            <p className="names">提示</p>
            <p className="text">
              1、您可修改求职者手机号
            </p>
            <p className="text">
              2、确认无误后点击【确认】按钮，系统将发送授权短信给求职者，请及时联系对方在24小时内，查收登录【58同城】开头的短信登录授权
            </p>
            <p className="text">
              3、求职者授权通过后，即可查看背调结果
            </p>
            <div className="modal-btn">
              <div className="cancel" onClick={this.onCloseAgenModel}>取消</div>
              <div className="confirm" onClick={this.agenOk}>确认</div>
            </div>
          </div>
        </Modal>
      </div >
    )
  }
  componentDidMount() {
    this.getData(1, 1);
  }
  // tab切换
  callback = (key) => {
    this.setState({
      key: key,
      index: 1,
    });
    this.getData(key, 1);
  }
  // 页码切换
  onChange = (index) => {
    this.setState({
      index: index,
    });
    const { key } = this.state;
    this.getData(key, index);
  }

  // 请求数据
  getData(index, pageNum) {
    this.setState({
      dataList: {},
    })
    let params = {
      pageSize: 10,
      pageNum: pageNum,
      authState: Number(index),
    }
    getRecordData(params).then((data) => {
      this.setState({
        dataList: data,
      })
    }).catch(() => {

    })
  }
  // 删除
  handleCloseClick = (authId, keys) => {
    this.authId = authId;
    this.keys = keys;
    this.setState({
      isShowModal: true,
    })
  }
  onCloseModel = () => {
    this.setState({
      isShowModal: false
    })
  }
  onCloseAgenModel = () => {
    this.setState({
      agenModal: false
    })
  }
  handleDeleteClick = () => {
    removeRecord(this.authId)
      .then(() => {
        this.getData(this.keys, 1);
        this.setState({
          isShowModal: false
        })
      }).catch(() => { })
  }
}


export default ResultHistory;
